import { navigateWindow } from '@/router/routerUtils';
import Vue from 'vue';
export default Vue.extend({
    props: {
        isEmpty: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        goToCart() {
            navigateWindow('cart');
        },
        goToCheckout() {
            navigateWindow('checkout');
        },
    },
});
